import React from 'react';
import styles from '../DataTablePanel/styles.css';
import { useTranslation } from 'react-i18next';

export default function BarChartPanel({ sortBySettings, sortDirectionSettings, groupHighlights }) {
	const { t } = useTranslation();
	return (
		<div className="idp-footer__middle advanced-settings">
			<div className="uk-width-1-2@s">
				{groupHighlights && groupHighlights.options.length ? (
					<div className={styles.groupHighlightSelectContainer}>
						<span>{groupHighlights.header}:</span>

						<select
							className={styles.groupHighlightSelect}
							onChange={(e) => {
								groupHighlights.selected = e.target.value;
								groupHighlights.onChange(e);
							}}
							value={groupHighlights.selected}
						>
							<option value="">{t(`Select group to highlight`)}</option>
							{groupHighlights.options.map((option, index) => (
								<option key={index} value={option.value}>
									{option.text}
								</option>
							))}
						</select>
					</div>
				) : null}
			</div>
			<div className="uk-width-1-2@s">
				<div>
					<label className={`reduced-size-label clickable_pointer`}>{sortBySettings.title}</label>
					<div>
						{sortBySettings.options.map((option) => {
							return (
								<label className={`reduced-size-label clickable_pointer`}>
									<input
										checked={option.checked}
										type="radio"
										onClick={() => {
											if (option.checked) {
												return;
											}
											option.onClick();
										}}
									/>
									{option.label}
								</label>
							);
						})}
					</div>
				</div>
				<div>
					<label className={`reduced-size-label clickable_pointer`}>{sortDirectionSettings.title}</label>
					<div>
						{sortDirectionSettings.options.map((option) => (
							<label className={`reduced-size-label clickable_pointer`}>
								<input
									checked={option.checked}
									type="radio"
									onClick={() => {
										if (option.checked) {
											return;
										}
										option.onClick();
									}}
								/>
								{option.label}
							</label>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
